import React, { Component } from "react";
import "./App.css";
import { connect } from "react-redux";
import Sidebar from "./Components/SideBar/Sidebar";
import { allcampaigns } from "./Components/Contacts/contactQuery";
import { fetchMethod } from "./FetchMethod";

class App extends Component {
  constructor() {
    super();
    this.state = {
      id: "",
      name: [],
      role: undefined,
      campaignId: undefined
    };
  }
  componentWillMount() {
    this.contactCampaignsId();
  }

  componentDidMount() {
    // this.fetchRole();
    const loggedInUserId = localStorage.getItem("userId");
    const loggedInUserName = localStorage.getItem("role");
    let sessionTime = new Date();
    sessionTime.setHours(sessionTime.getHours());
    this.props.handleSessionTime(sessionTime);
    this.setState({ id: loggedInUserName });
    this.props.handleUserDetails(loggedInUserId);
    sessionStorage.setItem("time", sessionTime);
  }

  contactCampaignsId = () => {
    const filter =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              campaignadminid: localStorage.getItem("id"),
              active: 1
            }
          }
        : localStorage.getItem("role") === "SADMIN"
        ? {
            where: {
              active: 1
            }
          }
        : localStorage.getItem("role") === "CAMPAIGNMANAGER"
        ? {
            where: {
              campaignmanagerid: localStorage.getItem("id"),
              active: 1
            }
          }
        : {
            where: {
              customerid: localStorage.getItem("customer"),
              active: 1
            }
          };
    fetchMethod(allcampaigns, filter)
      .then(response => {
        return response.json();
      })
      .then(res => {
        res !== undefined
          ? this.setState(
              {
                campaignId: res.data.allCampaigns.Campaigns
              },
              () => {
                this.props.handleCampaignId(this.state.campaignId);
              }
            )
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };

  render() {
    return (
      <div className="App">
        <Sidebar />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleSessionTime: time => {
      dispatch({
        type: "LOGGEDIN_USER_NAME",
        payload: time
      });
    },
    handleUserDetails: id => {
      dispatch({
        type: "LOGGEDIN_USERID",
        payload: id
      });
    },
    handleCampaignId: data =>
      dispatch({
        type: "Handle_CampaignId",
        payload: data
      })
  };
};

const mapStateToProps = state => {
  return {
    userName: state.userName
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
